import { useAppBranding } from './useAppBranding';

export function useAppName() {
  const { fullName } = useAppBranding();
  return fullName;
}
